// Copyright (c) StrangeBee 2023

import { Route as RouteList } from './List';
import { RouteView } from './List';
import { Route as RouteDetails } from './Details';

export const Routes = [RouteView, RouteList, RouteDetails];
